'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = currentStep;

var _immutable = require('immutable');

var _CurrentStepActionTypes = require('../actionTypes/CurrentStepActionTypes');

var INITIAL_STATE = new _immutable.Map({
  key: null,
  number: 0,
  totalSteps: null
});

function currentStep() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _CurrentStepActionTypes.UPDATE_CURRENT_STEP:
      return state.merge(payload);
    default:
      return state;
  }
}
module.exports = exports['default'];